import TabUsability from './components/tabUsability/tabUsability';
import EpiserverForm from './components/episerverForm/episerverForm';
import { wrap } from './components/utilities/utilities';
import objectFitImages from 'object-fit-images';
import Flickity from 'flickity';
import './libs/pannellum';
import 'flickity-imagesloaded';
import moreInfo from './components/moreInfo/moreInfo';
import designSectionLeftMenu from './components/designsectionLeftMenu/designSectionLeftMenu';
import designSectionMobile from './components/designsectionMobile/designSectionMobile';
import graduatesFilter from './components/graduatesFilter/graduatesFilter';
import graduatesFilterMobile from './components/graduatesFilter/graduatesFilterMobile';
import reportFilter from './components/reportFilter/reportFilter';
import rellax from 'rellax';
import { checkRemoveSessionStorage } from './components/utilities/utilities-designsection';

/**
 * App
 * This starting point for this application.
 * @version 3.0.0
 * @exports AppDesignSection
 */
export default class AppDesignSection {
    constructor() {
        // Init tabUsability
        new TabUsability();

        // Init table wrap for mobile scrolling of tables in rte.
        this._initRteTableWrap();

        // Init ajaxForm
        this._initAjaxForm();

        // Init episerverForms
        this._initEpiserverForm();

        // Init Flickity
        this._initFlickity();
        let flickityGrad = this._initFlickityGraduatesMobile();
        this._initPanorama();

        this._initExternalSearch();

        this._initTruncation();

        // Demo plugins (for demo purpose only, remove this when you build a new web).
        this._loadPluginsDemonstration();

        this._initImageZoom();

        objectFitImages();
        checkRemoveSessionStorage();

        const moreInfoExpandable = document.querySelectorAll('.more-info');
        if (moreInfoExpandable.length) {
            new moreInfo(moreInfoExpandable);
        }

        const expandable = document.querySelectorAll('.menu-design-section__first-lvl .expand-link');
        if (expandable.length) {
            new designSectionLeftMenu(expandable);
        }

        new designSectionMobile();

        const relax = document.querySelector('.rellax');
        const wrapper = document.querySelector('.rellaxwrapper');
        let rell = null;
        if (relax) {
            rell = new rellax('.rellax', {
                wrapper: '.rellaxwrapper',
            });
        }

        const newsPageWrapper = document.querySelector('.news-page-wrapper');
        if (newsPageWrapper) {
            rell = new rellax('.rellax', {
                wrapper: '.rellaxwrapper',
                callback: function () {
                    //Ugly solution..... gonna fix this.
                    wrapper.classList.toggle('relaxwrapper-overide');
                },
            });
        }

        const filterForm = document.querySelector('#graduate-filter');
        if (filterForm) {
            let scrollList = document.querySelector('.scroll-list');

            window.addEventListener('click', function (e) {
                const select = document.querySelector('.custom-select-sidenav');
                if (!select.contains(e.target)) {
                    select.classList.remove('open');
                }
            });

            for (
                var i = 0;
                i < document.querySelectorAll('.custom-option-sidenav').length;
                i++
            ) {
                const option = document.querySelectorAll('.custom-option-sidenav')[i];
                option.addEventListener('click', function () {
                    if (!this.classList.contains('selected')) {
                        this.parentNode
                            .querySelector('.custom-option-sidenav.selected')
                            .classList.remove('selected');
                        this.classList.add('selected');
                        this.closest('.custom-select-sidenav').querySelector(
                            '.custom-select__trigger span'
                        ).textContent = this.textContent;
                    }
                    var event = new Event('change');
                    filterForm.dispatchEvent(event);
                });
            }

            var indexClick = 0;
            document
                .querySelector('.custom-select-wrapper-sidenav')
                .addEventListener('click', function () {
                    this.querySelector('.custom-select-sidenav').classList.toggle('open');
                    let filter = document.querySelector(
                        '.designsection-header__filter__form'
                    );

                    if (indexClick === 0) {
                        filter.classList.toggle('override-visibility');
                    }
                    indexClick++;
                });

            if (scrollList) {
                new graduatesFilter(scrollList, filterForm, rell);
            }
        }

        let reportForm = document.querySelector('#report-years');
        if (reportForm) {
            let reportList = document.querySelectorAll('[data-report]');

            window.addEventListener('click', function (e) {
                const select = document.querySelector('.custom-select-report');
                if (!select.contains(e.target)) {
                    select.classList.remove('open');
                }
            });

            for (
                var indexMobRepo = 0;
                indexMobRepo <
                document.querySelectorAll('.custom-option-report').length;
                indexMobRepo++
            ) {
                const option = document.querySelectorAll('.custom-option-report')[
                    indexMobRepo
                ];
                option.addEventListener('click', function () {
                    if (!this.classList.contains('selected')) {
                        this.parentNode
                            .querySelector('.custom-option-report.selected')
                            .classList.remove('selected');
                        this.classList.add('selected');
                        this.closest('.custom-select-report').querySelector(
                            '.custom-select__trigger span'
                        ).textContent = this.textContent;
                    }
                    var event = new Event('change');
                    reportForm.dispatchEvent(event);
                });
            }

            document
                .querySelector('.custom-select-wrapper-report')
                .addEventListener('click', function () {
                    this.querySelector('.custom-select-report').classList.toggle('open');
                });

            if (reportList) {
                new reportFilter(reportList, reportForm);
            }
        }

        let filterFormMobile = document.querySelector('#graduate-filter-mobile');
        if (filterFormMobile) {
            window.addEventListener('click', function (e) {
                const select = document.querySelector('.custom-select-mobile');
                if (!select.contains(e.target)) {
                    select.classList.remove('open');
                }
            });

            for (
                var indexMob = 0;
                indexMob < document.querySelectorAll('.custom-option-mobile').length;
                indexMob++
            ) {
                const option = document.querySelectorAll('.custom-option-mobile')[
                    indexMob
                ];
                option.addEventListener('click', function () {
                    if (!this.classList.contains('selected')) {
                        this.parentNode
                            .querySelector('.custom-option-mobile.selected')
                            .classList.remove('selected');
                        this.classList.add('selected');
                        this.closest('.custom-select-mobile').querySelector(
                            '.custom-select__trigger span'
                        ).textContent = this.textContent;
                    }
                    var event = new Event('change');
                    filterFormMobile.dispatchEvent(event);
                });
            }

            document
                .querySelector('.custom-select-wrapper-mobile')
                .addEventListener('click', function () {
                    this.querySelector('.custom-select-mobile').classList.toggle('open');
                });

            let textileList = document.querySelectorAll('[data-graduate-mobile]');
            if (textileList) {
                new graduatesFilterMobile(textileList, filterFormMobile, flickityGrad);
            }
        }

        var textBlocks = document.querySelector('.design-section-block');
        if (textBlocks != null) {
            var preambleClass = textBlocks.parentNode.classList.contains(
                'small-screen-page-hide-preamble-text'
            );
            if (preambleClass != null) {
                textBlocks.parentNode.classList.remove(
                    'small-screen-page-hide-preamble-text'
                );
            }
            var mainBodyTextClass = textBlocks.parentElement.parentElement.classList.contains(
                'main-body-text'
            );
            if (mainBodyTextClass) {
                textBlocks.parentElement.parentElement.classList.remove(
                    'main-body-text'
                );
            }
        }

        let NewsItemWrapper = document.querySelectorAll('[data-newslist]');

        if (NewsItemWrapper) {
            document.addEventListener('DOMContentLoaded', function () {
                NewsItemWrapper.scrollLeft = 90;
            });
        }
    }

    /**
     * Function that initiates the ajax-form functionality.
     * @private
     */
    _initAjaxForm() {
        let els = document.querySelectorAll('[data-type="ajaxForm"]') || [];
        if (els.length === 0) {
            return;
        }

        import(
			/* webpackChunkName: "ajaxForm" */ './components/ajaxForm/ajaxForm'
        ).then(AjaxForm => {
            for (let i = 0; i < els.length; i++) {
                let el = els[i];

                if (el.getAttribute('data-ajaxform-initiated') === null) {
                    new AjaxForm.default(el);
                    el.setAttribute('data-ajaxform-initiated', true);
                }
            }
        });
    }

    /**
     * Function that initiates the episerverform functionality.
     * @private
     */
    _initEpiserverForm() {
        let els = document.querySelectorAll('[data-type="episerverForm"]');
        if (els.length === 0) {
            return;
        }

        for (let i = 0; i < els.length; i++) {
            let el = els[i];

            if (el.getAttribute('data-episerverform-initiated') === null) {
                new EpiserverForm(el);
                el.setAttribute('data-episerverform-initiated', true);
            }
        }
    }

    /**
     * Function that wraps all tables in rte with a div to enable the scroll-feature in mobile.
     * @private
     */
    _initRteTableWrap() {
        let els = document.querySelectorAll('.rte table');

        els.forEach(el => {
            let wrapper = document.createElement('div');
            wrapper.classList.add('table-scrollable');
            wrap(el, wrapper);
        });
    }

    _initFlickityGraduatesMobile() {
        const graduateNodes = document.querySelectorAll(
            '.design-section-graduate-carousel'
        );

        let graduateFlikity = [];
        var i = 0;
        graduateNodes.forEach(carousel => {
            const flkty = new Flickity(carousel, {
                // on: {
                // 	ready: function () {
                // 		console.log('Flickity is ready');
                // 		let el = document.querySelectorAll('.flickity-slider')[0];

                // 		el.classList.add('image-offset');

                // 	},
                // 	change: function () {
                // 		console.log('Flickity is changed');
                // 		let el = document.querySelectorAll('.flickity-slider')[0];
                // 		el.classList.remove('image-offset');
                // 	}

                // },
                cellAlign: i === 1 ? 'right' : 'left',
                contain: true,
                wrapAround: true,
                autoPlay: false,
                imagesLoaded: true,
                freeScroll: true,
                // lazyLoad: 2,
            });
            i++;
            graduateFlikity.push(flkty);

            const controlsWrapper = carousel.parentNode.querySelector(
                '.carousel-controls'
            );
            if (controlsWrapper != null && controlsWrapper != undefined) {
                const pauseBtn = controlsWrapper.querySelector('.pause-play');
                const fragment = document.createDocumentFragment();

                fragment.appendChild(carousel.querySelector('.flickity-page-dots'));
                controlsWrapper.appendChild(fragment);

                pauseBtn.addEventListener('click', e => {
                    e.preventDefault();

                    const iconBtn = pauseBtn.querySelector('.icon');

                    if (iconBtn.classList.contains('icon-pause')) {
                        flkty.pausePlayer();
                        iconBtn.classList.remove('icon-pause');
                        iconBtn.classList.add('icon-play');
                    } else {
                        flkty.unpausePlayer();
                        iconBtn.classList.remove('icon-play');
                        iconBtn.classList.add('icon-pause');
                    }
                });
            }
        });

        return graduateFlikity;
    }

    _initFlickity() {
        const carouselNodes = document.querySelectorAll('.main-carousel');

        carouselNodes.forEach(carousel => {
            const flkty = new Flickity(carousel, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                autoPlay: false,
                imagesLoaded: true,
                adaptiveHeight: true,
            });

            const controlsWrapper = carousel.parentNode.querySelector(
                '.carousel-controls'
            );
            if (controlsWrapper != null && controlsWrapper != undefined) {
                const pauseBtn = controlsWrapper.querySelector('.pause-play');
                const fragment = document.createDocumentFragment();

                fragment.appendChild(carousel.querySelector('.flickity-page-dots'));
                controlsWrapper.appendChild(fragment);

                pauseBtn.addEventListener('click', e => {
                    e.preventDefault();

                    const iconBtn = pauseBtn.querySelector('.icon');

                    if (iconBtn.classList.contains('icon-pause')) {
                        flkty.pausePlayer();
                        iconBtn.classList.remove('icon-pause');
                        iconBtn.classList.add('icon-play');
                    } else {
                        flkty.unpausePlayer();
                        iconBtn.classList.remove('icon-play');
                        iconBtn.classList.add('icon-pause');
                    }
                });
            }
        });
    }

    /**
     * Initiates 360 panorama image block
     */
    _initPanorama() {
        const panoramaElements = document.querySelectorAll('.panorama');

        panoramaElements.forEach(el => {
            // eslint-disable-next-line no-undef
            pannellum.viewer(el, {
                type: el.getAttribute('data-type'),
                panorama: el.getAttribute('data-src'),
                autoLoad: el.getAttribute('data-autoload') === 'true' ? true : false,
            });
        });
    }

    /**
     * Initiates forms directed to external sites
     */
    _initExternalSearch() {
        const formElement = document.querySelector('[data-type="externalSearch"]');

        if (formElement) {
            const visibleQueryName = formElement.getAttribute('data-visible-query');
            const hiddenQueryName = formElement.getAttribute('data-hidden-query');

            formElement.addEventListener('submit', () => {
                const visibleQuery = formElement.querySelector(
                    `[name="${visibleQueryName}"]`
                );
                const hiddenQuery = formElement.querySelector(
                    `[name="${hiddenQueryName}"]`
                );
                hiddenQuery.value = hiddenQuery.value + visibleQuery.value;
            });
        }
    }

    /**
     * Initiates truncation of texts in standard-blocks
     */

    _initTruncation() {
        let standardBlocks = document.querySelectorAll(
            '.standard-block__content--small'
        );

        standardBlocks.forEach(block => {
            let dateLabel = block
                .querySelector('.standard-block__news')
                .querySelector('.standard-block__label');
            let heading = block.querySelector('.standard-block__heading');
            let text = block.querySelector('.standard-block__text');
            if (heading !== null) {
                // One row
                if (heading.innerText.length < 30) {
                    if (dateLabel !== null && text.innerHTML.length > 200) {
                        text.innerHTML = text.innerText.slice(0, 200) + '...';
                    }
                }
                // Two rows
                else if (
                    heading.innerText.length >= 30 &&
                    heading.innerText.length < 60
                ) {
                    if (dateLabel !== null && text.innerHTML.length > 160) {
                        text.innerHTML = text.innerText.slice(0, 160) + '...';
                    }
                    if (dateLabel === null && text.innerHTML.length > 200) {
                        text.innerHTML = text.innerText.slice(0, 200) + '...';
                    }
                }
                // Three rows
                else if (
                    heading.innerText.length >= 60 &&
                    heading.innerText.length < 80
                ) {
                    if (dateLabel !== null && text.innerHTML.length > 120) {
                        text.innerHTML = text.innerText.slice(0, 120) + '...';
                    }
                    if (dateLabel === null && text.innerHTML.length > 160) {
                        text.innerHTML = text.innerText.slice(0, 160) + '...';
                    }
                }

                // Four rows
                else if (
                    heading.innerText.length >= 80 &&
                    heading.innerText.length < 120
                ) {
                    if (dateLabel !== null && text.innerHTML.length > 60) {
                        text.innerHTML = text.innerText.slice(0, 60) + '...';
                    }
                    if (dateLabel === null && text.innerHTML.length > 120) {
                        text.innerHTML = text.innerText.slice(0, 120) + '...';
                    }
                }
            }
        });
    }
    /**
     * Loads all plugins
     * @private
     */
    _loadPluginsDemonstration() {
        if (document.querySelectorAll('[data-type="loadMore"]').length > 0) {
            import(
				/* webpackChunkName: "loadMore" */ './components/loadMore/loadMore'
            ).then(LoadMore => {
                new LoadMore.default();
            });
        }

        if (document.querySelectorAll('[data-type="autosubmit"]').length > 0) {
            import(
				/* webpackChunkName: "autoSubmit" */ './components/autoSubmit/autoSubmit'
            ).then(AutoSubmit => {
                new AutoSubmit.default();
            });
        }
    }

    _initImageZoom() {
        const pageContainer = document.querySelector('.design-section');
        const scrollList = pageContainer && pageContainer.querySelector('.scroll-list');
        const column = scrollList && scrollList.closest('.design-section__column');

        if (!column) {
            return;
        }

        // �ppna
        column.addEventListener('click', event => {
            if (event.target.classList.contains('big-image-close')) {
                event.preventDefault();
                const bigImage = event.target.closest('.graduate-item-big-image');
                toggleImage(bigImage, false);
                return;
            }

            const imageLink = event.target.classList.contains('image-link') ? event.target : event.target.closest('.image-link');
            if (imageLink) {
                event.preventDefault();
                const bigImage = document.getElementById(imageLink.getAttribute('aria-controls'));
                toggleImage(bigImage, true);
                return;
            }
        });

        function toggleImage(bigImage, state) {
            if (!bigImage) {
                return;
            }

            if (state === true) {
                const img = bigImage.querySelector('img');
                if (img) {
                    img.src = img.getAttribute('data-bigimage-src');
                }

                bigImage.classList.toggle('hidden', false);
                bigImage.firstElementChild.classList.toggle('hidden', false);

                if (scrollList) {
                    scrollList.classList.toggle('hidden', true);
                    pageContainer.classList.remove('graduatePageClass');

                    if (bigImage.lastElementChild.classList.contains('hidden')) {
                        bigImage.lastElementChild.classList.toggle('hidden',);
                        pageContainer.classList.add('graduatePageClass');
                    }
                }
            } else if (state === false) {
                bigImage.classList.add('hidden');
                scrollList.classList.remove('hidden');
                pageContainer.classList.add('graduatePageClass');
            }
        }
    }
}
